export interface IState {
    photo: string | null
    isUploading: boolean
    error: string | null
}

export interface IAction {
    type: 'SET_IMAGE_SOURCE' | 'SET_IS_UPLOADING' | 'SET_ERROR'
    payload?: any
}

export const initialState: IState = {
    photo: null,
    isUploading: false,
    error: null,
}
